// extracted by mini-css-extract-plugin
module.exports = {"news":"style_news__nF0Qr"};